module.exports = __webpack_public_path__ + "static/media/OpenChoice.43eda4bf.svg";